import React, {Component} from 'react';
import { Trans, translate } from 'react-i18next';
import Form from 'react-validation/build/form';
import Input from 'react-validation/build/input';
import {required,email,isValidForm} from '../../../server/validationMethods.js'
import {personModal,personType}from './schoolLunchBreakfastModal.js'
import {BASE_URL} from "../../../server/constants"
import {get} from "../../../server/actionsParent.js"
class FirstParentInfo extends Component {
    constructor(props) {
        super(props)
        this.state={
            loading:false,
            }
    }
    
render(){
    const {lunchObj}=this.props;
    const { t, i18n } = this.props;
    return(
        <div>
            <div className="row">
                <div className="col-xs-12 block">
                
                    <div className="schoolInfo">
                        <h3 className="color-1"><Trans>I certify (promise)</Trans>...</h3>
                        <p><Trans>that all information on this application is true and that all income is reported</Trans>.</p>
                        <p> <Trans>I understand that this information is given in connection with the receipt of federal funds, and that school officials may verify (check) the information</Trans>. <Trans>I am aware that if I purposely give false information, my children may lose meal benefits, and I may be prosecuted under applicable state and federal laws</Trans>.</p>
                        <p><strong><Trans>Enter the name of the adult household member completing the application</Trans>.</strong></p>
                    </div>
                    
                </div>
            </div>
            <Form ref={f=>this.frmPrimAdultInfo=f}>
            <div className="row">
                <div className="col-xs-12">
                    <div className="row">
                        <div className="col-md-3">
                            <label><Trans>First Name</Trans> *</label>
                            <Input type="text" name="fname" className="form-control" placeholder={t("First")} 
                                value={lunchObj.persons[0].fname} 
                                validations={[required]} requiredmsg={t('Please provide parent first name')+'.'} onChange={(e)=>{
                                    this.props.onApplicantFieldChange(e.target.name,e.target.value);
                                }}
                            />
                        </div> 
                        <div className="col-md-2">
                            <label><Trans>Middle Name</Trans></label>
                            <Input type="text" name="mname" className="form-control" placeholder={t("Middle")}
                            value={lunchObj.persons[0].mname} 
                            onChange={(e)=>{
                                    this.props.onApplicantFieldChange(e.target.name,e.target.value);
                                }}/>
                        </div> 
                        <div className="col-md-3">
                            <label><Trans>Last Name</Trans> *</label>
                            <Input type="text" name="lname" className="form-control" placeholder={t("Last")}
                            value={lunchObj.persons[0].lname} 
                            validations={[required]} requiredmsg={t('Please provide parent last name')+'.'} 
                            onChange={(e)=>{
                                    this.props.onApplicantFieldChange(e.target.name,e.target.value);
                                }}/>
                        </div>
                    </div>
                </div>
            </div>
            <div className="row" style={{paddingTop:'12px'}}>
            <div className="col-md-3 form-group">            
        <label><Trans>E-Mail</Trans> </label>
                <input type="text" name="email" className="form-control" placeholder={t("Email")}
                    value={lunchObj.persons[0].contact.email} onChange={(e)=>{
                        let _contact=lunchObj.persons[0].contact;
                        _contact.email=e.target.value;
                                    this.props.onApplicantFieldChange('contact',_contact);
                                }}
                />
            </div>
            </div>
            </Form>
            <div className="row">
                <div className="col-xs-12">
                        <button className="btn btn-next bg-color-4 btn-xs pull-left" onClick={(e)=>{
                        this.props.jumpToStep(1)
                    }}>
                        <Trans>Previous</Trans>
                    </button>
                    <button className="btn btn-prev btn-xs bg-color-2 pull-right" onClick={(e)=>{
                        this.frmPrimAdultInfo.validateAll();
                            if(!isValidForm(this.frmPrimAdultInfo)){
                                return false;
                            }else{
                                this.props.jumpToStep(3);
                                // this.buildStudentsList();
                            }
                    }}><Trans>Continue</Trans>
                    </button>
                </div>
            </div>
        </div>
    )
}
}
export default translate("translations")(FirstParentInfo);


// WEBPACK FOOTER //
// ./src/components/Parent/SchoolLunchBreakfastProgram/firstParentInfo.jsx